import { Component, Input, OnInit } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { BatchStatus } from '../masterdata/models/batchStatus';
import { SelectableLab } from '../carrier/selectable-lab';
import * as cloneDeep from 'lodash/cloneDeep';
import * as omit from 'lodash/omit';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MachineType } from '../masterdata/models/machineType';
import { BBResponseContainer } from '../carrier/response-container';
import { MasterList } from '../masterdata/masterList-enum';

@Component({
    selector: 'app-batch-status',
    templateUrl: './batch-status.component.html',
    styleUrls: ['./batch-status.component.css']
  })
export class BatchStatusComponent implements OnInit { 

    @Input() masterLists: Array<BatchStatus>;

    @Input() tableCols: Array<BatchStatus>;
    
    @Input() masterListType: MasterList;

    @Input() title: string;

    @Input() checkSelectedLab: SelectableLab;

    @Input() machineTypesOptions: MachineType[];

    errorHandler: ErrorHandler = new ErrorHandler();

    @Input() selectedLab: SelectableLab;

    batchStatus: BatchStatus;

    selectedMasterList: BatchStatus;

    masterList: any;

    _labOptions: Array<LabMDM>;    
    
    typesOfMachines:any[]=[];
    
    selectedLabId: string;

    selectedMachineType: MachineType;

    workfileType:Array<any>;
    
    selectedWorkFileType:any;

    labOption: LabMDM[] = [];

    machineType: MachineType[]=[];
    
    batchStatusData: any;
    
    
    @Input() set labOptions(input: LabMDM[]) {
        this._labOptions = input.filter((lab: LabMDM) => lab.name === this.checkSelectedLab.lab.name);
      }
      
      statusName: string;

      displayName: string;

      showbatchStatus: boolean;

      finalState: boolean;

      active: boolean;

      selectableLab: SelectableLab;

      selectedDisplayName: any;

      selectedBatchStatus: any;

      showBatchStatusDialoguge: boolean;

     constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
      this.showErrorOnSave = this.showErrorOnSave.bind(this);
      this.showErrorOnUpdate = this.showErrorOnUpdate.bind(this);
    }
    ngOnInit(): void {
    this.masterLists = [];
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;

        this.workfileType = [
            {label: 'No Workfile', value: 'No Workfile'},
            {label: 'ABI Sample Sheet', value: 'ABI Sample Sheet'},
            {label: 'ECHO Workfile', value: 'ECHO Workfile'}
          ]
           this.selectedWorkFileType=null;
           
    }
     
      handleAddNewBatchStatus() {
        this.batchStatus = { finalState: false, active: true };
        this.selectedWorkFileType = null;
        this.showBatchStatusDialoguge = true;
        this.getTypeOfMachines();
      }

      handleSaveOrUpdate(){
      const { _id } = this.batchStatus;
       if (this.isValid()) {
      this.batchStatus.visibleName = this.batchStatus.statusName;
      this.batchStatus.workFileType = this.selectedWorkFileType.value;
      if(this.batchStatus.machineTypes === 'No Machine' ){
              this.batchStatus.machineTypes=null;
      }
       if(this.batchStatus.workFileType === 'No Workfile'){
         this.batchStatus.workFileType=null;        

       }

      if (_id) {
        this._masterDataService.updateBatchStatus(JSON.stringify(this.batchStatus), this.selectedLabId, _id).subscribe((response) => {
          this.showBatchStatusDialoguge = false;
          const selectedBatchStatusIndex: number = this.masterLists.findIndex((batchStatusData: BatchStatus) => batchStatusData._id === _id);
          this.masterLists[selectedBatchStatusIndex] = response;
        }, this.showErrorOnUpdate);
      } else {
        this._masterDataService.createBatchStatus(JSON.stringify(this.batchStatus), this.selectedLabId, "batchstatus").subscribe((response: BBResponseContainer) => {
          const { data } = response;
          this.masterLists.push(data);
          this.showBatchStatusDialoguge = false;
        }, this.showErrorOnSave);
      }
    }
   }

   showErrorOnSave(){
     this._messageService.addErrorMessage({
       severity: 'error', summary: 'Error',
       detail: 'Failed to create Batch Status. Try with other Status name, may be it is duplicate'
     });
   }
  
  showErrorOnUpdate(){
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: 'Failed to update BatchStatus. Try with other status name, may be it is duplicate'
    });
  }

  isValid() {
    const {  displayName = '' ,machineTypes} = this.batchStatus;
    this.batchStatus =omit(this.batchStatus, ['nameError',  'locationError', 'displayerror', 'machineError']);
      if (!displayName || displayName==='') {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Display Name',
        detail: 'Display Name cannot be empty'
      });
      (this.batchStatus as any).nameError = true;
      return false;
    } 
      else if (!machineTypes || machineTypes==='') {
       this._messageService.addErrorMessage({
         severity: 'error', summary: 'MachineType',
         detail: 'MachineType cannot be empty'
       });
       (this.batchStatus as any).nameError = true;
        return false;
      } 
      else if (!this.selectedWorkFileType) {
        this._messageService.addErrorMessage({
          severity: 'error', summary: 'WorkFileType',
          detail: 'Please select workFileType'
        });
        (this.batchStatus as any).nameError = true;
         return false;
       } 
    return true;
  }

  handleRowSelect(event: any) {
    const { data } = event;
    const { lab = {} } = data;
    const { _id = '' } = lab;
    this.batchStatus = cloneDeep(data);
    this.batchStatus.lab = this._labOptions.find((labOption: LabMDM) => labOption._id === _id);
    this.typesOfMachines=[];
    this._masterDataService.getActiveMachineTypes(true,this.selectedLabId).subscribe(
      results => {
        if (!results) {
          return;
        }

        this.machineType = results.data;
        this.machineType.forEach(machinetype => {
          if(machinetype.name!=this.batchStatus.machineTypes){
          this.typesOfMachines.push({ label: machinetype.name, value: machinetype.name });
          }
        });
        
        
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
    if(this.batchStatus.machineTypes!=null){
      this.typesOfMachines.push({ label: 'No Machine', value: 'No Machine'});
      this.typesOfMachines.push({ label: this.batchStatus.machineTypes, value: this.batchStatus.machineTypes });
    }
     else{
       this.typesOfMachines.push({ label: this.batchStatus.machineTypes='No Machine', value: this.batchStatus.machineTypes='No Machine'});
     }
    this.showBatchStatusDialoguge = true;
  }
  isSaveDisabledBatchStatus() {
    if (this.batchStatus == undefined || this.batchStatus == null)
      return true;
    if (!this.batchStatus.statusName || this.batchStatus.statusName.trim() == "" || !this.batchStatus.lab) {
      return true;
    }
}
    private getTypeOfMachines(){
     
      this.typesOfMachines=[];
      this._masterDataService.getActiveMachineTypes(true, this.selectedLabId).subscribe(
      
        results => {
          if (!results) {
            return;
          }
          
          this.machineType = results.data;
          this.typesOfMachines.push({label:'No Machine', value:'No Machine'});
          this.machineType.forEach(machinetype => {
           this.typesOfMachines.push({ label: machinetype.name, value: machinetype.name });
          });
          
      
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

    }
           
}


